import { coreRangeFromRequest } from "@CommonUtils/cdtStudio/domain/pogAesthetics";
import type { CoreRange } from "@CommonUtils/cdtStudio/domain/aestheticsScore";

/** Business review distinguishes explicitly configured core range from required store range.
 * The native grading request and its combined required-product contract are unchanged. */
export const reviewCoreRangeFromRequest = (request: unknown): CoreRange => {
  const source = request && typeof request === "object" ? (request as Record<string, unknown>) : {};
  const distribution =
    source.min_distribution && typeof source.min_distribution === "object"
      ? (source.min_distribution as Record<string, unknown>)
      : {};
  return (
    coreRangeFromRequest({
      ...source,
      min_distribution: {
        core_range_items: distribution.core_range_items,
        store_range_items: { required_items: [] },
      },
    }) ?? { source: "request", skuIds: [] }
  );
};
